import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import accessGroupMemberships from 'modules/dashboard/store/collections/AccessGroupMemberships'
import groups from 'modules/dashboard/store/collections/communities/Groups'

interface Props {
  onClose: () => void
  groupId: number
}

function LeaveGroup({ onClose, groupId }: Props) {
  const [running, setRunning] = React.useState(false)

  const group = groups.find({
    id: groupId,
  })

  const accessGroup = group?.accessGroup

  const { loading } = useAsyncData(
    () =>
      groups.fetch({
        data: {
          id: groupId,
        },
        remove: false,
      }),
    [groupId]
  )

  const submit = async (closePortal: ClosePortalFn) => {
    if (!accessGroup) return

    setRunning(true)

    const { success, value: membership } = await asyncAction(() => group.rpc('leave'))
    setRunning(false)

    if (success) {
      accessGroupMemberships.remove(membership.id)
      closePortal()
    }
  }

  return (
    <Modal
      description={i18n.t('dashboard.groups.leave.description')}
      illustration="delete-cross"
      onClose={onClose}
      onSubmit={submit}
      title={i18n.t('dashboard.groups.leave.title')}
      footer={
        <Button disabled={loading || !group || running} submit>
          {i18n.t('dashboard.groups.leave.title')}
        </Button>
      }
    />
  )
}

export default observer(LeaveGroup)
